import { normalizeLang, translations } from "../../utils/i18n";

export const PASSWORD_RULES = [
  { key: "length", test: (pw) => pw.length >= 8 },
  { key: "uppercase", test: (pw) => /[A-Z]/.test(pw) },
  { key: "lowercase", test: (pw) => /[a-z]/.test(pw) },
  { key: "number", test: (pw) => /[0-9]/.test(pw) },
  { key: "symbol", test: (pw) => /[^A-Za-z0-9]/.test(pw) },
];

export function isPasswordValid(password) {
  return PASSWORD_RULES.every((rule) => rule.test(password));
}

export default function PasswordRequirements({ password, open, language }) {
  const labels = translations[normalizeLang(language)].passwordRules;
  return (
    <div className={open ? "password-rules-collapse is-open" : "password-rules-collapse"}>
      <div className="password-rules-collapse-inner">
        <ul className="password-rules">
          {PASSWORD_RULES.map((rule) => {
            const met = rule.test(password);
            return (
              <li key={rule.key} className={met ? "password-rule is-met" : "password-rule"}>
                <span className="password-rule-icon">{met ? <CheckIcon /> : <XIcon />}</span>
                {labels[rule.key]}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

function CheckIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}

function XIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  );
}
